/*
 * File: ui-label.ts
 * File Created: 2023-12-18 11:45:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-18 12:47:14
 * Modified By: Val Liu
 * -----
 */

import {
    BaseUITag,
    IUITagInput,
    IUITagResult,
    EUITagTarget,
    UITag,
    EUITagRuleType,
    EUITagRuleUnion,
} from "./core";
import { lang } from "@root/core/i18n";

// @uiConverter - convert the original value to another.

@UITag.set()
export class uiConverter extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.TableBodyCell, EUITagTarget.FormElement];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Meta];
    allowNullRule: boolean = false;

    /// set props :value
    parse(input: IUITagInput): IUITagResult | null {
        const rule = this.parseRule(input);
        /// return when undefined, but allow null.
        if (rule === undefined) return null;

        return {
            props: {
                value: rule,
            },
        };
    }
}
